import z from 'zod';
import { stripePriceIdValue, stripePriceLookupKeyValue, stripeProductIdValue, subscriptionPlanIdValue, } from '../value-objects/stripe-ids';
import { billingPeriodValue, domainValue, firmTypologyValue, subscriptionPaymentMethodValue, subscriptionPlanValue, } from '../value-objects/subscription-enums';
export const resolvedSubscriptionProductSchema = z.object({
    billingPeriod: billingPeriodValue,
    domain: domainValue,
    firmTypology: firmTypologyValue,
    plan: subscriptionPlanValue,
    planId: subscriptionPlanIdValue,
    stripePriceId: stripePriceIdValue.optional(),
    stripePriceLookupKey: stripePriceLookupKeyValue,
    stripeProductId: stripeProductIdValue,
    subscriptionPaymentMethod: subscriptionPaymentMethodValue,
});
export const resolvedSubscriptionProductsSchema = z.array(resolvedSubscriptionProductSchema);
//# sourceMappingURL=resolved-subscription-product.js.map